import { inject, Injectable } from "@angular/core";
import { WebsocketClientWrapper } from "../../market/websocket-client-factory";
import { BinancePositionHandler } from "./exchange/binance-position.handler";
import { BybitPositionHandler } from "./exchange/bybit-position.handler";
import { OkxPositionHandler } from "./exchange/okx-position.handler";

@Injectable({
  providedIn: 'root'
})
export class PositionHandler {

  private bybitHandler = inject(BybitPositionHandler)
  private binanceHandler = inject(BinancePositionHandler)
  private okxHandler = inject(OkxPositionHandler)

  listen(ws: WebsocketClientWrapper) {
    if (ws.isBybit) {
      return this.bybitHandler.listen(ws.bybit)
    }
    if (ws.isBinance) {
      return this.binanceHandler.listen(ws.binance)
    }
    if (ws.isOkx) {
      return this.okxHandler.listen(ws.okx)
    }
    throw new Error(`Unknown WebsocketClientWrapper`)
  }

}
